import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { UserListAction } from './userList.action';
import { userListInitialState } from './userList.constant';

export const userListReducer = reducerWithInitialState(userListInitialState)
  .cases([UserListAction.load, UserListAction.loadClient], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(UserListAction.loadDone, (state, payload) => {
    return {
      ...state,
      list: payload.list,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(UserListAction.loadFailed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(UserListAction.setFilter, (state, payload) => {
    return {
      ...state,
      filter: payload,
    };
  })

  .cases([UserListAction.remove.started, UserListAction.removeClient.started], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(UserListAction.remove.done, (state, payload) => {
    return {
      ...state,
      list: state.list.filter((user) => user.userId !== payload.params.userId),
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(UserListAction.removeClient.done, (state, payload) => {
    return {
      ...state,
      list: state.list.filter((user) => user.userId !== payload.params.userId),
      networkStatus: NetworkStatus.Done,
    };
  })
  .cases([UserListAction.remove.failed, UserListAction.removeClient.failed], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })

  .case(UserListAction.destroy, () => ({
    ...userListInitialState,
  }));
